export const DRAFT_SCOPE_KIND = {
  TEXT_ONLY: 'textOnly',
  MEDIA_ONLY: 'mediaOnly',
  BOTH: 'both',
};

const resolveDraftScopeChrome = ({ isDraftLayer, draftDomains } = {}) => {
  if (!isDraftLayer) return null;

  const text = Boolean(draftDomains?.text);
  const media = Boolean(draftDomains?.media);

  if (text && !media) {
    return {
      kind: DRAFT_SCOPE_KIND.TEXT_ONLY,
      hideDetails: false,
      showEditMedia: true,
      showEditText: true,
    };
  }

  if (media && !text) {
    return {
      kind: DRAFT_SCOPE_KIND.MEDIA_ONLY,
      hideDetails: true,
      showEditMedia: true,
      showEditText: true,
    };
  }

  if (text && media) {
    return {
      kind: DRAFT_SCOPE_KIND.BOTH,
      hideDetails: false,
      showEditMedia: true,
      showEditText: true,
    };
  }

  return null;
};

export default resolveDraftScopeChrome;
